import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import { FormProvider } from "./context/FormContext";
import { EntriesDataProvider } from "./context/EntriesDataContext";
import { VideoProvider } from "./context/VideoContext";
import "react-toastify/dist/ReactToastify.min.css";
import { ToastContainer } from "react-toastify";
import "./index.css";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <EntriesDataProvider>
        <VideoProvider>
          <FormProvider>
            <App />
            <ToastContainer />
          </FormProvider>
        </VideoProvider>
      </EntriesDataProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
